import { apiClient } from '../apiClient';

export type InterviewType = 'ONLINE' | 'OFFLINE';
export type InterviewResult = 'PASSED' | 'FAILED';
export type GraphSyncStatus = 'PENDING' | 'SYNCED' | 'FAILED' | 'NOT_CONFIGURED';

export type InterviewSchedule = {
  id: string;
  application_id: string;
  interview_round: string;
  interview_type: InterviewType;
  interview_result: InterviewResult | null;
  start_at: string;
  duration_minutes: number;
  interviewer: {
    id: string | null;
    display_name: string;
    email: string;
  };
  interviewers: Array<{
    id: string | null;
    display_name: string;
    email: string;
  }>;
  meeting_room: string | null;
  meeting_link: string | null;
  note: string | null;
  graph_event_web_link: string | null;
  graph_sync_status: GraphSyncStatus;
  graph_sync_error: string | null;
  reminder_sent_at: string | null;
  created_at: string;
  updated_at: string;
};

export type InterviewerOption = {
  id: string;
  display_name: string;
  email: string;
};

export type SaveInterviewPayload = {
  interview_round: string;
  interview_type: InterviewType;
  interview_result?: InterviewResult | null;
  interview_date: string;
  start_time: string;
  duration_minutes: number;
  interviewer_user_id?: string;
  interviewer_user_ids: string[];
  meeting_room?: string | null;
  note?: string | null;
};

export const listInterviews = (applicationId: string) =>
  apiClient.get<{ items: InterviewSchedule[] }>(`/applications/${applicationId}/interviews`);

export const listInterviewers = () =>
  apiClient.get<{ items: InterviewerOption[] }>('/interviewers');

export const createInterview = (applicationId: string, payload: SaveInterviewPayload) =>
  apiClient.post<InterviewSchedule>(`/applications/${applicationId}/interviews`, payload);

export const updateInterview = (
  applicationId: string,
  scheduleId: string,
  payload: SaveInterviewPayload,
) =>
  apiClient.patch<InterviewSchedule>(
    `/applications/${applicationId}/interviews/${scheduleId}`,
    payload,
  );

export const updateInterviewResult = (
  applicationId: string,
  scheduleId: string,
  interviewResult: InterviewResult | null,
) =>
  apiClient.patch<InterviewSchedule>(
    `/applications/${applicationId}/interviews/${scheduleId}/result`,
    {
      interview_result: interviewResult,
    },
  );
